import { Component, Input } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { Select } from '@ngxs/store';
import { Observable } from 'rxjs';
import {
  Footer,
  Property,
  Section,
  SocialShare,
} from '../../../dto/response/template.config';
import { TemplateConfigService } from '../../../service/template-config.service';
import { TemplateConfigState } from '../../../store/states/templateConfig.state';
import { SubFooterComponent } from './sub-footer/sub-footer.component';
import { FooterContactComponent } from './widgets/footer-contact/footer-contact.component';
import { FooterLinksComponent } from './widgets/footer-links/footer-links.component';
import { FooterLogoComponent } from './widgets/footer-logo/footer-logo.component';

@Component({
  selector: 'app-footer',
  standalone: true,
  imports: [
    TranslateModule,
    FooterLogoComponent,
    FooterContactComponent,
    FooterLinksComponent,
    SubFooterComponent,
  ],
  templateUrl: './footer.component.html',
  styleUrl: './footer.component.scss',
})
export class FooterComponent {
  @Input() logo: string | undefined;

  @Select(TemplateConfigState.templateConfigFooter)
  footerConfig$: Observable<Footer>;
  footerConfig: Footer;
  footerSection: Section | undefined;
  footerSectionContact: Section | undefined;
  footerSectionMenu: Section | undefined;
  menuConfig: Property | undefined;
  socialConfig: Property | undefined;

  footerSectionSocial: Section | undefined;
  subFooterSection: Section | undefined;
  readonly SOCIAL_SHARE: typeof SocialShare = SocialShare;
  public active: { [key: string]: boolean } = {};

  constructor(private templateConfigService: TemplateConfigService) { }

  ngOnInit() {
    this.footerConfig$.subscribe((footer) => {
      this.footerConfig = footer;
      // Footer section
      this.footerSection = this.findSection(this.footerConfig, 'footer');
      if (this.footerSection?.sub_sections) {
        // this.footerSectionContact = this.findSectionInSections(this.footerSection.sub_sections, 'contact');
        // this.footerSectionMenu = this.findSectionInSections(this.footerSection.sub_sections, 'menu');
        // this.footerSectionSocial = this.findSectionInSections(this.footerSection.sub_sections, 'social_links');
      }
      this.menuConfig = this.templateConfigService.findConfig(
        this.footerSection!.config,
        'menu',
      );
      this.socialConfig = this.templateConfigService.findConfig(
        this.footerSection!.config,
        'socials_links',
      );
      // subfootersection
      this.subFooterSection = this.findSection(this.footerConfig, 'sub-footer');
    });
  }

  toggle(value: string) {
    this.active[value] = !this.active[value];
  }

  private findSection(
    footerConfig: Footer,
    sectionId: string,
  ): Section | undefined {
    return this.templateConfigService.findSectionById(
      footerConfig.sections,
      sectionId,
    );
  }

  private findSectionInSections(
    footerSections: Section[],
    sectionId: string,
  ): Section | undefined {
    return this.templateConfigService.findSectionById(
      footerSections,
      sectionId,
    );
  }
}
